import {defaultsDeep} from 'lodash-es';

const DEFAULT_NEW_GUIDE = {
    entranceIsRead: true,
    searchPageIsRead: true,
    tagRecommendIsRead: true,
    newBuildIsRead: true,
    tagDepartKnowledgeIsRead: true,
    SettingModeIsRead: true,
    endMeetingModeIsRead: true,
    ShareCollaborateIsRead: true,
    createDirectoryGuideIsRead: true,
    collaboratorAvatarGuideIsRead: true,
    myDepartmentIsRead: true,
    unifyReadWriteIsRead: true,
    mydepartRemindIsRead: true,
    meetingModeIsRead: true,
    customIsRead: true,
    sheetGuideIsRead: true,
    departVideoIsRead: true,
    moveInBook: true,
    moveOutBook: true,
    departmentHelpIsRead: true,
    homeReadStep: 2,
};

// 默认设置，用于补充缺省的设置项
const DEFAULT_SETTINGS = {
    newGuide: DEFAULT_NEW_GUIDE,
    newSettings: {
        intelligent: {
            useSpaceKey: true,
            openAIAgent: true,
            openOCR: true,
        },
    },
};

/**
 * 补充默认设置项
 *
 * @param settings 用户设置项
 * @returns 返回完整的设置项
 */
export function makeUpSettings(settings: User['settings']) {
    return defaultsDeep(settings, DEFAULT_SETTINGS);
}
